// frontend styles
import '../../scss/frontend/styles.scss';

// manifest
import 'pwacompat/src/pwacompat';

// add better focus and input type detection on body element (for development)
// import 'what-input';

// components
//import './components/pageTransition';
import './components/aucorNavigation';
import './components/sliders';
import './components/headerAnimation';
import './components/pageTitleAnimation';
import './components/lazyLoading';
import './components/lottie';
import './components/intro';
import './components/rombe';
import './components/modal';
import './components/languageSwitcher';
